import { PlotSection } from '@/warranty-v3/components/plot-section';
import { Card, CardContent } from '@/warranty-v3/components/ui/card';
import type { DataResult } from '@/warranty-v3/entities/data-result';

import { OverviewIntroBox } from './overview-intro-box';
import { OverviewTable } from './overview-table';

export type OverviewProps = {
  unitOverview: DataResult['unitOverview'];
};

export function Overview({ unitOverview }: OverviewProps) {
  if (unitOverview.columns.length === 0) {
    return null;
  }

  return (
    <PlotSection sectionName="Overview Table">
      <Card className="w-full overflow-x-auto">
        <CardContent>
          <OverviewIntroBox />
          <OverviewTable unitOverview={unitOverview} />
        </CardContent>
      </Card>
    </PlotSection>
  );
}
